export default {
	"ShareModal.ShareTips": "分享提示",
	"ShareModal.ShareWithFriends": "分享给好友",
	"ShareModal.ClickTheOneInTheTopRightCorner": "点击右上角的",
	"ShareModal.buttonToShare": "按钮分享。",
	"ShareModal.GenerateAPoster": "生成海报",
	"ShareModal.ClickTheGeneratePosterButtonToSaveThePosterImage": "点击生成海报按钮，进行海报图片保存。"
}